import api from "lib/axios";
import { ApiEnvelope, PaginatedResult, unwrapData, unwrapList } from "./apiTypes";

type EntityPayload = Record<string, unknown>;
type Query = Record<string, unknown> | undefined;
type ActiveEntityPayload = EntityPayload & { is_active?: boolean | number | string };

function normalizeActivePayload(data: ActiveEntityPayload): EntityPayload {
  return {
    ...data,
    is_active:
      data?.is_active === undefined
        ? true
        : String(data.is_active) === "1" || String(data.is_active).toLowerCase() === "true",
  };
}

type ListConfig = { signal?: AbortSignal };

async function list<T>(endpoint: string, params?: Query, config?: ListConfig) {
  const response = await api.get<ApiEnvelope<PaginatedResult<T>>>(endpoint, {
    params,
    meta: { toastSuccess: false },
    ...config,
  });
  return unwrapList(response.data);
}

async function show<T>(endpoint: string) {
  const response = await api.get<ApiEnvelope<{ data: T }>>(endpoint, {
    meta: { toastSuccess: false },
  });
  return unwrapData(response.data);
}

async function create<T>(endpoint: string, data: EntityPayload) {
  const response = await api.post<ApiEnvelope<{ data: T }>>(endpoint, data);
  return unwrapData(response.data);
}

async function update<T>(endpoint: string, data: EntityPayload) {
  const response = await api.put<ApiEnvelope<{ data: T }>>(endpoint, data);
  return unwrapData(response.data);
}

async function remove(endpoint: string) {
  const response = await api.delete(endpoint);
  return response.data;
}

export const academicService = {
  // Stages
  listStages: (params?: Query, config?: ListConfig) => list<any>("/mcp/stages", params, config),
  getStage: (id: number | string) => show<any>(`/mcp/stages/${id}`),
  createStage: (data: EntityPayload) => create<any>("/mcp/stages", data),
  updateStage: (id: number | string, data: EntityPayload) =>
    update<any>(`/mcp/stages/${id}`, data),
  deleteStage: (id: number | string) => remove(`/mcp/stages/${id}`),

  // Grades
  listGrades: (params?: Query, config?: ListConfig) => list<any>("/mcp/grades", params, config),
  getGrade: (id: number | string) => show<any>(`/mcp/grades/${id}`),
  createGrade: (data: ActiveEntityPayload) =>
    create<any>("/mcp/grades", normalizeActivePayload(data)),
  updateGrade: (id: number | string, data: ActiveEntityPayload) =>
    update<any>(`/mcp/grades/${id}`, normalizeActivePayload(data)),
  deleteGrade: (id: number | string) => remove(`/mcp/grades/${id}`),

};
